<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="form.items"
            ref="Table"
            sort-by="dataAtendimento"
        >

            <template v-slot:cell(cns)="{ item }">
                {{ item.cns | formatCns }}
            </template>

            <template v-slot:cell(dataExportacao)="{ item }">

                <span v-if="item.dataExportacao">
                    {{ item.dataExportacao }} às {{ item.horarioExportacao }} - {{ item.profissionalExportacao }}
                </span>
                <span v-else>-</span>
            </template>

            <template v-slot:cell(actions)="row">
                <rkm-button
                    @click="$router.push({
                        name: 'atencao-basica-marcador-consumo-alimentar-edit',
                        params: {
                            id: row.item.id
                        }
                    })"
                    color="primary"
                    title="Editar"
                    small
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click.stop="handleDestroy(row.item.id)"
                    color="danger"
                    title="Excluir"
                    small
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>

// Mixins
import { error, repository } from '@/mixins'

// Vuex
import { mapActions } from 'vuex'

// Filters.
import formats from '@/filters/formats'

export default {
    data() {
        return {
            form: {},
            fields: [
                {
                    key: 'dataAtendimento',
                    label: 'Data',
                    sortable: true,
                },
                {
                    key: 'nome',
                    label: 'Profissional',
                    sortable: true
                },
                {
                    key: 'cns',
                    label: 'CNS',
                    sortable: true
                },
                {
                    key: 'nomeFantasia',
                    label: 'Unidade',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'dataExportacao',
                    label: 'Exportação',
                },
                {
                    name: 'actions',
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    created() {
        this.repositories = {
            marcadorConsumoAlimentar: this.getConectaSusRepository('atencaoBasica.marcadorConsumoAlimentar')
        }
    },
    mounted() {
        this.load()
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {

                const request = this.repositories.marcadorConsumoAlimentar.historico(this.id)

                request
                    .then(response => {
                        this.form = {items: response.data.form.map(item => Object.assign({}, item))}
                        this.$emit('paciente', response.data.paciente)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleDestroy(id) {
            const destroy = () => this.repositories.marcadorConsumoAlimentar.destroy(id)
                .then(() => this.form.items.splice(this.form.items.findIndex(i => i.id === id), 1))

            this.showDeleteConfirmation('Deseja realmente excluir o marcador?', destroy, this.handleError)
        }
    },
    filters: {
        ...formats
    },
    mixins: [ error, repository ],
    props: { id: { type: Number, default: null } }
}

</script>